import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

const MetricsCards = ({ vertical = false }) => {
  const metricsData = [
    {
      id: 1,
      title: 'Totals Scans',
      value: '2500',
      trend: { percentage: '1.3%', direction: 'up', text: 'Up from past week' },
      iconSrc: '/total-scan-metric.png',
    },
    {
      id: 2,
      title: 'Total Sales',
      value: '2000',
      trend: { percentage: '1.3%', direction: 'up', text: 'Up from past week' },
      iconSrc: '/sales-metric.png',
    },
    {
      id: 3,
      title: 'Types of Products',
      value: '10',
      trend: { percentage: '4.3%', direction: 'down', text: 'Down from yesterday' },
      iconSrc: '/product-type-metric.png',
    },
    {
      id: 4,
      title: 'Total Items',
      value: '2000',
      trend: { percentage: '1.8%', direction: 'up', text: 'Up from yesterday' },
      iconSrc: '/item-metric.png',
    }
  ];

  return (
    <div className={vertical ? "flex flex-col gap-4" : "grid grid-cols-2 gap-4"}>
      {metricsData.map((metric) => (
        <div
          key={metric.id}
          className="bg-white rounded-lg p-4 shadow-sm border border-gray-100"
        >
          <div className="flex items-start justify-between mb-3">
            <div className="flex-1">
              <p className="text-xs text-gray-600 font-medium mb-2">{metric.title}</p>
              <h3 className="text-2xl font-bold text-gray-900">{metric.value}</h3>
            </div>
            <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
              {metric.iconSrc ? (
                <img src={metric.iconSrc} alt={metric.title} className="w-12 h-12 object-contain" />
              ) : (
                <div className="w-4 h-4 bg-gray-300 rounded" />
              )}
            </div>
          </div>
          <div className="flex items-center gap-1">
            {metric.trend.direction === 'up' ? (
              <TrendingUp className="w-3 h-3 text-green-600" />
            ) : (
              <TrendingDown className="w-3 h-3 text-red-600" />
            )}
            <span className={`text-xs font-semibold ${metric.trend.direction === 'up' ? 'text-green-600' : 'text-red-600'}`}>
              {metric.trend.percentage}
            </span>
            <span className="text-xs text-gray-500">{metric.trend.text}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricsCards;